export const tertiaryColorScale = {
    0: "#000000",
    5: "#001419",
    10: "#001F26",
    15: "#002A33",
    20: "#003640",
    25: "#00424E",
    30: "#004E5C",
    35: "#3D546E",
    40: "#00687A",
    50: "#008399",
    60: "#249EB7",
    70: "#4BB9D2",
    80: "#6BD5EF",
    90: "#ACEDFF",
    95: "#D8F6FF",
    98: "#F0FBFF",
    99: "#F8FDFF",
    100: "#FFFFFF",
};
